import link from "@/scripts/host.js";

export default {
  name: 'artistInfo',
  data() {
    return {
      artist: null,
      songs: null
    }
  },
  methods: {
    goToSong(id) {
      if(!this.$route.path.includes(`/utwór/${id}`)){
        this.$router.push(`/utwór/${id}`)
      }
    }
  },
  mounted() {
    const artistId = this.$route.params.id;
    this.axios.get(`${link.hostLink}Artist/GetDetails?id=${artistId}`).then((response) => {
      this.artist = response.data;
      this.axios.get(`${link.hostLink}Artist/GetSongs?id=${artistId}`).then((response) =>{
        this.songs = response.data;
      })
    })
  }
}
